module.exports = __webpack_public_path__ + "static/scale-model-of-pier-60-visitor-center-in-clearwater-florida-27ce5f65cb81521f6c41e7808b16bef6.png";